import TWEEN from '@tweenjs/tween.js';
//数字动画效果
export const numberTweenAnimate = (startValue, endValue, updateCallback, duration = 800) => {
    new TWEEN.Tween({ value: startValue })
        .to({ value: endValue }, duration)
        .onUpdate(e => {
            updateCallback && updateCallback(e);
        })
        .start();

    function animate() {
        if (TWEEN.update()) {
            requestAnimationFrame(animate);
        }
    }
    animate();
};
